import {Box} from '@mui/material';
import {shell} from '../../theme/tokens';
import {SidebarContent} from './SidebarContent';

/** Signed-in navigation at ≥1200px: a fixed 232px column, no top bar. */
const Sidebar = () => (
  <Box
    data-testid="shell-sidebar"
    sx={{
      display: {xs: 'none', lg: 'block'},
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      width: shell.sidebarWidth,
      bgcolor: 'background.paper',
      borderRight: 1,
      borderColor: 'divider',
      overflowY: 'auto',
      zIndex: (t) => t.zIndex.appBar,
    }}>
    <SidebarContent />
  </Box>
);

export default Sidebar;
